@if (authService.currentUser()?.email && !authService.currentUser()?.emailVerified) {
  <button type="button" (click)="onClick()"
    class="inline-flex items-center gap-[4px] text-[11px] font-medium text-[#b45309] bg-[#fff8e1] border-[1px] border-solid border-[#f0d98c] rounded-[999px] px-[8px] py-[2px] hover:bg-[#fdf0c9]">
    <i class="ri-error-warning-line text-[12px]"></i> Unverified
  </button>
}
